import React from 'react';
import { Mail, Phone, MessageCircle, MapPin } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contato" className="nexti-gradient text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Empresa */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="/nexti-logo.png" 
                alt="NexTI" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              NexTI Soluções Inteligentes em TI - Conectando segurança, performance e
              inovação para empresas que não podem parar.
            </p>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contato</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span>{contactInfo.email}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <span>{contactInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <MessageCircle className="w-5 h-5 flex-shrink-0" />
                <span>WhatsApp: {contactInfo.whatsapp}</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 flex-shrink-0" />
                <span>{contactInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-xl font-bold mb-4">Links Rápidos</h3>
            <div className="space-y-2 text-sm">
              <button
                onClick={() => scrollToSection('home')}
                className="block hover:text-white/80 transition-colors"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('servicos')}
                className="block hover:text-white/80 transition-colors"
              >
                Serviços
              </button>
              <button
                onClick={() => scrollToSection('contato')}
                className="block hover:text-white/80 transition-colors"
              >
                Contato
              </button>
              <button
                onClick={() => scrollToSection('diferenciais')}
                className="block hover:text-white/80 transition-colors"
              >
                Diferenciais
              </button>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 mt-12 pt-8 text-center text-sm text-white/80">
          <p>© 2024 NexTI Soluções Inteligentes em TI. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;